import { Navigate, Outlet, useLocation } from "react-router-dom";
import { CardSpinner } from "./CardSpinner";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center px-4">
        <div className="flex flex-col items-center gap-3">
          <CardSpinner className="h-12 w-12" color="#FF5100" />
          <p className="text-sm text-smoke">On restaure ta session.</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
